import React from 'react'
import { Stack, Group, Text, Paper, Divider, SimpleGrid, ActionIcon } from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'
import { router } from '@inertiajs/react'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import { Review } from '../../../types'
import { VehicleCard, VehicleVersion } from './components/VehicleCard'
import { PointsCard } from './components/PointsCard'
import { NotesGrid } from './components/NotesGrid'
import { ReferredReviewsTable } from './components/ReferredReviewsTable'
import { CommentCard } from './components/CommentCard'
import { SectionLabel } from './components/SectionLabel'

dayjs.locale('fr')

type AdminReviewsShowProps = { review: Review }

const AdminReviewsShow: React.FC<AdminReviewsShowProps> = ({ review }) => {
  const vehicle = review.vehicle_version as unknown as VehicleVersion

  return (
    <Stack gap="xl">
      <Group gap={6} align="center">
        <ActionIcon variant="subtle" color="gray" size="sm" onClick={() => router.visit('/admin/reviews')}>
          <IconArrowLeft size={15} />
        </ActionIcon>
        <Text size="sm" c="dimmed">Avis</Text>
        <Text size="sm" c="dimmed">/</Text>
        <Text size="sm" fw={500}>Détail de l'avis</Text>
        <Text size="xs" c="dimmed" ml={8}>
          {dayjs(review.created_at).format('DD MMMM YYYY à HH:mm')}
        </Text>
        <Text size="xs" c="dimmed" ml="auto">#{review.id}</Text>
      </Group>

      <VehicleCard vehicle={vehicle} note={review.note} />

      <NotesGrid review={review} />

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        <PointsCard type="tops" text={review.tops} />
        <PointsCard type="flops" text={review.flops} />
      </SimpleGrid>

      {review.comment && <CommentCard comment={review.comment} />}

      <Paper p="lg" radius="md" withBorder>
        <Stack gap="md">
          <SectionLabel>Avis parrainés ({review.referred_reviews?.length || 0})</SectionLabel>
          <Divider />
          <ReferredReviewsTable reviews={review.referred_reviews ?? []} />
        </Stack>
      </Paper>
    </Stack>
  )
}

export default AdminReviewsShow
